export default __webpack_public_path__ + "static/media/mist.1f946a6f.svg";